import { useState } from 'react';

import { CenterCoverImg, PCFooter } from '@commonPackage/components';
import { Tabs } from '@fuxi/eevee-ui';
import { MetaConfig } from '@portalCommon/components';
import { RouterConfigEnum } from '@portalCommon/constants';
import { SCENE_LIST, SCENE_TABS } from '@portalCommon/constants/scene';
import { useEnhancedNavigation } from '@portalCommon/hooks';

import classnames from 'classnames/bind';
import { Back2Top, Contact, ContactBox, NavHeader } from '@/components';

import Card from './Card';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const MaterialCenter = () => {
  const enhancedNavigate = useEnhancedNavigation();

  const handleClickItem = (e: any, item: any) => {
    // enhancedNavigate();
  };

  const [list, setList] = useState(SCENE_LIST);

  const handleTabChange = (key: string) => {
    const tmpList = SCENE_LIST.filter(item => item.type === key);
    setList(tmpList.length ? tmpList : SCENE_LIST);
  };

  return (
    <>
      <MetaConfig routerPath={RouterConfigEnum.Scene} />
      <NavHeader />
      <div className={cx('scene-page')}>
        <div className={cx('page-top')}>
          <div className={cx('title-wrap')}>
            <div className={cx('title')}>行业解决方案</div>
            <div className={cx('subtitle')}>
              在瑶台举办令人惊叹的虚拟会议、活动、展览。
              <br />
              我们提供丰富的行业解决方案，为您打造理想的在线活动。
            </div>
          </div>
          <CenterCoverImg
            width={1920}
            src="https://static.fuxi.netease.com/yaotai/portal/20220907/l7rcydfo_268227.png"
          />
        </div>
        <div className={cx('page-content')}>
          <Tabs onChange={handleTabChange} items={SCENE_TABS}></Tabs>
          <div className={cx('card-wrap')}>
            {list.map(item => (
              <Card key={item.id} item={item} click={handleClickItem}></Card>
            ))}
          </div>
        </div>
      </div>
      <Contact />
      <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} />
      <ContactBox />
      <Back2Top />
    </>
  );
};

export default MaterialCenter;
